/**
 * @file: isValidLicensePlateNo.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
const PLATE_NO_REGEX =
  /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}))$/i;

export function isValidLicensePlateNo(s: string) {
  if (s.length !== 7 && s.length !== 8) {
    return false;
  }
  return PLATE_NO_REGEX.test(s);
}
